/**
 * Copiar texto plano al portapapeles, con degradación.
 *
 * `navigator.clipboard` no existe en contextos no seguros ni en navegadores viejos, y ahí el botón
 * tiene que copiar igual en vez de fallar en silencio: el fallback mete el texto en un textarea
 * fuera de pantalla y usa `execCommand`.
 *
 * **Nunca lanza en forma sincrónica**: todo error sale como promesa rechazada, así el llamador
 * puede confiar en un solo camino (`.catch`) para avisar. Pegarle derecho a
 * `navigator.clipboard.writeText` —que en esos mismos contextos **tira sincrónicamente** dentro del
 * onClick— no copiaba, no encendía el estado de error y no dejaba rastro para el usuario.
 *
 * Vive en `utils/` y no en el Recorrido porque la usan superficies de tres frentes distintos: la
 * hoja "Como lo ve tu IA", las tarjetas de prompts de «Usa tu IA» y los chips del portal. Es una
 * función pura de plataforma; que viviera dentro de `client/ia_booster/memoria/` ataba el portal al
 * booster sin ninguna razón de dominio.
 */
export function copyPlainText(text) {
    try {
        if (typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.writeText) {
            return Promise.resolve(navigator.clipboard.writeText(text));
        }
    } catch (e) {
        return Promise.reject(e);
    }
    return new Promise((resolve, reject) => {
        try {
            const area = document.createElement('textarea');
            area.value = text;
            area.setAttribute('readonly', '');
            area.style.position = 'fixed';
            area.style.top = '-1000px';
            area.style.opacity = '0';
            document.body.appendChild(area);
            area.select();
            const copied = document.execCommand && document.execCommand('copy');
            document.body.removeChild(area);
            if (copied) resolve();
            else reject(new Error('COPY_UNSUPPORTED'));
        } catch (e) {
            reject(e);
        }
    });
}
